(function () {
    $(document).ready(function () {
        setTimeout(function () {
            var $autocompleteInput = $('.ui-autocomplete-input');
            var $autocompleteList = $('ul.ui-autocomplete');

            if ($autocompleteInput.length) {
                $autocompleteInput.on('autocompletesearch', function (event, ui) {
                    $autocompleteList.scrollTop(0);
                });
                $autocompleteInput.on('autocompleteopen', function (event, ui) {
                    $autocompleteList.scrollTop(0);
                });
            }
        }, 1000);
    });
})();
